export const GIFT_HOSPITALITY_DONATION_DUBAI_SECTION_KEYS = {
  giftHospitalityDonationDubaiRequestDetails: 'gift_hospitality_donation_dubai_request_details',
  giftHospitalityDonationDubaiApproval: 'gift_hospitality_donation_dubai_approval',
} as const;

export const GIFT_HOSPITALITY_DONATION_DUBAI_SECTION_TITLES = {
  giftHospitalityDonationDubaiRequestDetails: 'Request Details',
  giftHospitalityDonationDubaiApproval: 'Approval',
} as const;
